// The TWO icon sets (owner ruling 2026-10-21, 47179; styleguide Prompts/0.43/ui_foundations_styleguide.html "Icons"):
//  1. COLOURFUL EMOJI (this file) = every NON-action icon: login logo, section headers, KPI / tier glyphs, status chips and hints, labels in locale JSON (:id: shortcodes).
//  2. MONOCHROME LINE (ActionIcons.jsx, <IcoLn>/<IcoChip>, currentColor) = ACTION BUTTONS only (table icon buttons, chips, menu actions, toolbar buttons).
// Same ids as the line map (one meaning = one id). Emoji below are the pre-ef3f16ba characters (most frequent per id in that commit's diff; styleguide concept map wins on conflict).
// Ids in FUNCTIONAL stay on the line set in every context: they are action / control glyphs (styleguide: "functional controls (chevron, x, arrows, search) stay monochrome line").
// Emo / emoText fall back to <IcoLn> for those and for any id without an emoji, so a call site never breaks.
import React from 'react';
import { IcoLn } from './ActionIcons';
import './iconChips.css';

export const EMOJI = {
  lock: '🔒', warn: '⚠️', stop: '⛔', link: '🔗', check: '✓', flock: '🐔', mortality: '🕊️', egg: '🥚', feed: '🌾', money: '💵', trend: '📈', trendDown: '📉', calendar: '📅',
  scale: '⚖️', chart: '📊', bell: '🔔', forecast: '🔮', folder: '📁', water: '💧', thermo: '🌡️', manure: '💩', site: '🏢', farm: '🚜', target: '🎯', clipboard: '📋',
  shield: '🛡️', cart: '🛒', invoice: '🧾', pay: '💳', flask: '🧪', wrench: '🔩', home: '🏠', note: '📝', dna: '🧬', calc: '🧮', flag: '⚑', star: '★', account: '💳',
  modules: '🧩', chain: '🔗', globe: '🌐', item: '📦', delivery: '📦', archive: '🗄️', pin: '📍', customers: '👥', user: '🧑', storage: '🏭', dispatch: '🚚', crown: '👑',
  seat: '🪑', info: '💡', health: '🩺', bolt: '⚡', ship: '🚢', bot: '🤖', comment: '💬', transfer: '🔁',
  dotRed: '🔴', dotOrange: '🟠', dotYellow: '🟡', dotGreen: '🟢', dotGrey: '⚪', dotBlue: '🔵',
};
// Action / control ids: always the line glyph, never an emoji.
export const FUNCTIONAL = new Set(['view', 'order', 'gl', 'print', 'edit', 'trash', 'cancel', 'add', 'gear', 'more', 'close', 'download', 'upload', 'save', 'refresh', 'chevron', 'up', 'down', 'bold', 'italic',
  'search', 'filter', 'send', 'refund', 'duplicate', 'discount', 'menu', 'database']);

export function Emo({ name, size, className = '' }) {
  const e = EMOJI[name];
  if (!e || FUNCTIONAL.has(name)) return <IcoLn name={name} size={size} className={className} />;
  return <span className={`emo ${className}`.trim()} aria-hidden="true" style={size ? { fontSize: size } : undefined}>{e}</span>;
}

const CODE_RE = new RegExp(`:(${[...Object.keys(EMOJI), ...FUNCTIONAL].join('|')}):`, 'g');
// :id: shortcodes -> emoji text (a plain string when every id has an emoji; nodes with <IcoLn> for the functional ids).
export function emoText(s) {
  if (typeof s !== 'string' || !s.includes(':')) return s;
  const out = []; let last = 0, m, k = 0, buf = ''; CODE_RE.lastIndex = 0;
  while ((m = CODE_RE.exec(s))) {
    buf += s.slice(last, m.index); last = m.index + m[0].length;
    if (EMOJI[m[1]] && !FUNCTIONAL.has(m[1])) buf += EMOJI[m[1]];
    else { if (buf) out.push(buf); buf = ''; out.push(<IcoLn key={k++} name={m[1]} />); }
  }
  buf += s.slice(last);
  if (!out.length) return buf;
  if (buf) out.push(buf);
  return out;
}
